import PaneContainer from '@/layouts/components/PaneContainer'
import ApiIntegration from './sections/ApiIntegration'
import BasicControls from './sections/BasicControls'
import DataProcessing from './sections/DataProcessing'
import FormElements from './sections/FormElements'
import TailwindDemo from './sections/TailwindDemo'

interface RightPaneProps {
  selectedSection: string
}

function RightPane({ selectedSection }: RightPaneProps) {
  // セクションに基づいて表示するコンポーネントを選択
  const renderSection = () => {
    switch (selectedSection) {
      case 'basicControls':
        return <BasicControls />
      case 'formElements':
        return <FormElements />
      case 'dataProcessing':
        return <DataProcessing />
      case 'apiIntegration':
        return <ApiIntegration />
      case 'tailwindDemo':
        return <TailwindDemo />
      default:
        return <div>セクションを選択してください</div>
    }
  }

  return (
    <PaneContainer>
      {renderSection()}
    </PaneContainer>
  )
}

export default RightPane
